export const PERIOD_DROPDOWN_WIDTH = 402
